export const getEditFormConfig = [
	{
		el: "el-input",
		label: "人格类型名称",
		name: "name",
		attrs: {
			clearable: true,
			placeholder: "请填写人格类型名称",
		},
	},
	{
		el: "el-input",
		label: "人格代表人物",
		name: "figures",
		attrs: {
			clearable: true,
			placeholder: "请填写人格代表人物",
		},
	},
	{
		el: "rich-text",
		label: "总览-投资风格",
		name: "content",
		attrs: {
			keyWord: "content",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "总览-核心特征分析",
		name: "descr",
		attrs: {
			keyWord: "descr",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "总览-代表人物案例",
		name: "relationships",
		attrs: {
			keyWord: "relationships",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "投资策略建议",
		name: "suggest",
		attrs: {
			keyWord: "suggest",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "团队合作与沟通",
		name: "suggest2",
		attrs: {
			keyWord: "suggest2",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "后续测评与深度分析",
		name: "growth",
		attrs: {
			keyWord: "growth",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
	{
		el: "rich-text",
		label: "解决方案与资源",
		name: "careerDevelopment",
		attrs: {
			keyWord: "careerDevelopment",
			params: "",
		},
		show: {
			key: "innerVisible",
		},
	},
];
